module.exports = __webpack_public_path__ + "img/audience-network.463ba89e.svg";